import React, { useState } from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { useOnceReveal } from '@common/hooks';
import { Typography } from '@common/styles';

import { GetFittingModelList_pdp_base_info_fitting_model_list_item_list as Model } from '../../../../../model-size/graphql/fitting-model-list_types.2';

interface ModelItemProps {
  model: Model;
}

export const ModelItem: React.FC<React.PropsWithChildren<ModelItemProps>> = ({ model }) => {
  const { targetRef, isRevealed } = useOnceReveal();

  const [displayImagePlaceHolder, setDisplayImageHolder] = useState(true);

  const hidePlaceHolder = () => {
    setDisplayImageHolder(false);
  };

  const showPlaceHolder = () => {
    setDisplayImageHolder(true);
  };

  return (
    <Item ref={targetRef}>
      <Images>
        {isRevealed && <Image src={model.profile_image_url} onLoad={hidePlaceHolder} onError={showPlaceHolder} />}
        {displayImagePlaceHolder && <ImagePlaceHolder />}
      </Images>
      <Info>
        <Flex>
          <Name className={Typography.BODY_16_SEMIBOLD}>{model.name}</Name>
          {model.badge?.label && <Label className={Typography.CAPTION_9_MEDIUM}>{model.badge.label}</Label>}
        </Flex>
        <BodyInfo className={Typography.CAPTION_12_MEDIUM}>
          {model.size_text_list.map((item, index) => (
            <span key={`${item}-${index}`}>{item}</span>
          ))}
        </BodyInfo>
        {model.fitting_size_list && (
          <WearInfo className={Typography.BODY_14_MEDIUM}>
            {model.fitting_size_list.map((size) => `${size} 착용`).join(', ')}
          </WearInfo>
        )}
      </Info>
    </Item>
  );
};

const Item = styled.div`
  padding: 12px 0;
  display: flex;
`;

const Info = styled.div`
  padding: 6px 0 0 0;
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
`;
const Name = styled.p`
  color: ${vars.v3Color.gray900};
`;

const Label = styled.p`
  margin-left: 3px;
  padding: 0 4px;
  height: 14px;
  line-height: 14px;
  color: ${vars.v3Color.staticWhite};
  background-color: ${vars.v3Color.pink400};
  border-radius: 2px;
`;

const BodyInfo = styled.div`
  margin-top: 3px;
  color: ${vars.v3Color.gray400};

  span::after {
    content: '';
    display: inline-block;
    margin: 0 3px;
    width: 2px;
    height: 2px;
    background-color: ${vars.v3Color.gray200};
    vertical-align: middle;
  }
  span:last-of-type::after {
    display: none;
  }
`;

const WearInfo = styled.div`
  margin-top: 10px;
  color: ${vars.v3Color.gray600};
  word-break: break-all;
`;

const Images = styled.div`
  margin: 0 12px 0 0;
  position: relative;
  width: 48px;
  height: 48px;
`;

const Image = styled.img`
  width: 48px;
  height: 48px;
  border: 1px solid ${vars.v3Color.gray150};
  border-radius: 24px;

  &[src=''] {
    visibility: hidden;
  }
`;

const ImagePlaceHolder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 48px;
  height: 48px;
  border-radius: 24px;
  background-color: ${vars.v3Color.gray100};
`;
